import { render, staticRenderFns } from "./IconAndText.vue?vue&type=template&id=7c8e7716&"
import script from "./IconAndText.vue?vue&type=script&lang=ts&"
export * from "./IconAndText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports